import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HdButtonGroupModule } from "../hd-button-group/hd-button-group.module";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { NzTableModule } from "ng-zorro-antd/table";
import { HdButtonModule } from "../hd-button/hd-button.module";
import { HdSpaceModule } from "../hd-space/hd-space.module";
import { HdDetailLinesComponent } from "./hd-detail-lines.component";

@NgModule({
  imports: [
    CommonModule,
    NzTableModule,
    DragDropModule,
    FormsModule,
    NgZorroAntdModule,
    HdSpaceModule,
    HdButtonModule,
    HdButtonGroupModule,
  ],
  declarations: [HdDetailLinesComponent],
  exports: [HdDetailLinesComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class HdDetailLinesModule {}
